import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import React from 'react';
import { getFormComponent } from 'catalyst/core/form';

const FormField = ({
    field,
    index,
    errors,
    touched,
    values,
    style,
    fullWidth,
}) => {
    const { name, component, xs, sm, md } = field;

    const rest = { ...field };
    delete rest.component;
    const { helperText } = field;

    const FormComponent = getFormComponent(component);

    const err = touched && errors && touched[name] && Boolean(errors[name]);
    const text = touched && errors && touched[name] && errors[name];

    return (
        <Grid item xs={xs || 12} sm={sm || 12} md={md || 12} key={index}>
            <FormComponent
                fullWidth={fullWidth}
                style={style}
                {...rest}
                value={values && values[name]}
                error={err}
                helperText={text || helperText}
            />
        </Grid>
    );
};
export default FormField;

FormField.propTypes = {
    errors: PropTypes.object,
    field: PropTypes.object.isRequired,
    fullWidth: PropTypes.bool,
    index: PropTypes.number.isRequired,
    style: PropTypes.object,
    touched: PropTypes.object,
    values: PropTypes.object,
};

FormField.defaultProps = {
    errors: null,
    fullWidth: true,
    style: {},
    touched: null,
    values: null,
};
